import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { AuthLayout } from "@/pages/Login";

const FIELDS = [
  ["company_name", "Nome azienda", "text"],
  ["app_name", "Nome app", "text"],
  ["name", "Nome e cognome amministratore", "text"],
  ["email", "Email", "email"],
  ["password", "Password (min. 8 caratteri)", "password"],
];

export default function Setup() {
  const { signIn, loadSettings } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ company_name: "", app_name: "Nexora", name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/setup/status").then((r) => !r.data.needs_setup && nav("/login", { replace: true }));
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/setup", f);
      signIn(data.user);
      await loadSettings();
      nav("/", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Configurazione iniziale" subtitle="Crea il primo amministratore. Questa schermata è disponibile una sola volta.">
      <form onSubmit={submit} className="space-y-4" data-testid="setup-form">
        {FIELDS.map(([k, l, t]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={k}>{l}</Label>
            <Input id={k} type={t} value={f[k]} required={k !== "company_name"} minLength={k === "password" ? 8 : undefined}
              onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`setup-${k}-input`} />
          </div>
        ))}
        {err && <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="setup-error">{err}</p>}
        <Button type="submit" className="w-full" disabled={busy} data-testid="setup-submit-button">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Crea amministratore
        </Button>
      </form>
    </AuthLayout>
  );
}
